import { Compart } from '../compart/model';
import { Make, Model, Family, ResultMessage, Side, SystemType } from '../global/model';
export class SystemSetup {
  public Id: number = 0;
  public Serial: string = "";
  public JobsiteId: number = 0;
  public Type: SystemType = SystemType.Unknown;
  public EquipmentId: number = 0;
  public SmuAtInstall: number = 0;
  public HoursAtInstall: number = 0;
  public BudgetLife: number = 0;
  public UserId: number;
  public Cost: number;
  public Comment: string;
  public InstallOnEquipment: boolean = false;
  public SetupDate: Date = new Date();
  public InstallationDate: Date = new Date();
  public Components: ComponentSetup[] = [];
  public Make: Make = new Make();
  public Model: Model = new Model();
  public Family: Family = new Family();
  public Result: ResultMessage = new ResultMessage();
  public Side: Side = Side.Unknown;
  public InstallationDate_: string
  public frameConfig: number;
  public cannonType: number;
  public PMUAtInstall: number = 0;
  public PMUBudgetLife: number = 0;
  public PropelAtInstall: number = 0;
  public WorkOrder: string;
  public luUCIInventoryStatus: number;
  public FrameSerialRight: string = "";
  public HistoricalDistance: number = 0;
  public TotalDistance: number = 0;
  public BudgetDistance: number = 0;
  public FrameCost: number = 0;
  public KeepSystem: boolean = false;
  public IsWSREInspection: boolean = false;
}

export class ComponentSetup {
  public Id: number = 0;
  public SystemId: number = 0;
  public listPosition: number = 1;
  public Compart: Compart = new Compart();
  public Size: ComponentSize = new ComponentSize();
  public Grouser: ComponentGrouser = new ComponentGrouser();
  public Brand: Make = new Make();
  public BudgetLife: number = 0;
  public HoursAtInstall: number = 0;
  public InstallDate: Date = new Date(Date.now());
  public EquipmentSMU: number = 0;
  public InstallCost: number = 0;
  public Note: string = "";
  public Pos: number = 0;
  public Points: number = 1;
  public ShoeSize: ShoeSize = new ShoeSize();
  public ShoeGrouser: number = 1;
  public Result: ResultMessage = new ResultMessage();
  public Validity: boolean = false;
  public OEMPartNo: string;
  public MFRPartNo: string;
  public HasCleanerHoles: number;
  public PMUAtInstall: number = 0;
   public PMUBudgetLife: number = 0;
  public PropelHrs: number = 0;
  // public BushTurnedBudgetLife:number=0;
  public BushTurnedPercent: number = 75;
  public ActionWO: string;
  public UsedCMU: number;
  public UsedDOC: number;
  public UsedWorn: number = 0;
  public Measurement: number;
  public ToolId: number;
  public MLink: number;
  public JobNum: string;
  public AssetNum: string;
  public DOC: number;
  public DistanceBudget: number = 0;
  public KeepComponent: boolean = false;
}

export class ComponentSize {
  public Id: number = 0;
  public Title: string = "";
}

export class ComponentGrouser {
  public Id: number = 0;
  public Title: string = "";
}

export class ShoeSize {
  public Id: number = 0;
  public Title: string;
  public Size: number;
}

export class SystemModelTemplate {
  public Id: number = 0;
  public Name: string = "";
  public ModelId: number = 0;
  public CompartTypeId: number = 0;
  public Min: number = 0;
  public Max: number = 0;
}




export class SystemStructureInformation {
  public SystemId: number;
  public ComponentsOnSystem: ComponentOnSystem[];
}

export class ComponentOnSystem {
  public CompartTypeId: number;
  public EqUnitInfos: EqUnitInfo[];
}

export class EqUnitInfo {
  public GeneralEqUnitId: number;
  public BudgetLife: number;
  public CompartTypeId: number;
  public CompartId: number;
  public Position: number;
}

export class InventoryEquipmentPart {
  public Ischain: number;
  public IsFrame: number;
  public IsIdler: number;
  constructor(Ischain: number, IsFrame: number, IsIdler: number) {
    this.Ischain = Ischain;
    this.IsFrame = IsFrame;
    this.IsIdler = IsIdler;
  }
}

export class scrapedSystemId {
  SystemId: string;

  constructor(systemId: string) {
    this.SystemId = systemId;
  }
}

export class EqualiserBar {
  Id: number;
  EquipmentId: number;
  InspectionId?: number;
  InspDetailId?: number;
  SystemId: number;
  ToeOut: number;      // 1 = Toe Out, 2 = Straight
  BrandId?: number;
  Brand?: Make;
  BudgetLife?: number = 0;
  CMU?: number = 0;
  Cost?: number = 0;
  ToolAuto?: number;
  Reading?: number;
  Worn?: number;
  EvalCode?: string;
  Condition?: string;
  DateInstalled?: string;
  SMUAtInstall?: number;
  DisplayDateInstalled: Date;
  AddToAllInsp: boolean;
  LifeLived?: number;
  Make?: string;
  EqBarComment?: string;
  EqBarImages: EqualiserBarImages[];
  ActionId?: number;
  ActionTypeId?: number;
  ActionBudgetLife?: number;
  ActionBrandId?: number;
  ActionCMU?: number;
  ActionCost?: number;
  ActionComment?: string;
  NewEqBarTypeId?: number;
  ActionCondition?: string;
  MeasurementCenter?: number;
  MeasurementOuterLeft?: number;
  MeasurementOuterRight?: number;
  CompartName?: string;
  CompartId?: number
}

export class EqualiserBarImages {
  ImageId: number;
  InspectionId?: number;
  ImagePath: string;
  IsDeleted: boolean;
  ImageUrl: string;
  SystemId: number;
}